class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    let that = this;
    this.mainDetailsToggle.addEventListener('mouseover', function(){
        let summary = that.mainDetailsToggle.querySelector('summary');

        summary.parentElement.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
        // let firstChild = $(summary).children(":first");
        let firstChild = $(summary).children(":first").children(":first");
        let hasClass = firstChild.hasClass('header__active-menu-item');
        if(!hasClass){
          firstChild.addClass('menu_hover_border');
        }


    });
    this.mainDetailsToggle.addEventListener('mouseleave', function(){
      console.log('mainDetailsToggle2===',that.mainDetailsToggle)
        let summary = that.mainDetailsToggle.querySelector('summary');  
        summary.parentElement.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        let firstChild = $(summary).children(":first").children(":first");
        firstChild.removeClass('menu_hover_border');
        that.onFocusOut();
    });
  }

  onFocusOut() {
    setTimeout(() => {
      console.log('onFocusOut')
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    console.log('onToggle')

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {

    console.log('close')
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
